import React from 'react';
import { HeroSectionContent } from './HeroSectionContent';
import { useHeroSectionController } from './HeroSection.controllers';
import { WrapperBox, ForgroundCloudImage, AssetsWrapperBox, AssetsBox, ForgroundAssetsBox } from './HeroSection.styles';

export const HeroSectionDesktop: React.FC = () => {
  const assets = [
    {
      width: 760,
      right: '-75px',
      bottom: '-450px',
      zindex: '-1',
      src: 'careers/hero/bg-gradient-top-left-v3.png',
    },
    {
      width: 400,
      right: '406px',
      top: '25px',
      src: 'careers/hero/img.jpg',
    },
    {
      width: 236,
      right: '600px',
      top: '358px',
      src: 'careers/hero/post-its.jpg',
    },

    {
      width: 176,
      right: '280px',
      top: '358px',
      circle: true,
      bottom: '',
      left: '',
      src: 'careers/hero/circle1-v2.jpg',
    },
    {
      width: 450,
      left: '215px',
      top: '120px',
      src: 'careers/hero/bg-grid.svg',
    },
    {
      width: 260,
      left: '335px',
      top: '-100px',
      circle: true,
      bottom: '',
      src: 'careers/hero/circle2-v2.jpg',
    },
    {
      width: 430,
      left: '300px',
      top: '293px',
      src: 'careers/hero/pic-office.jpg',
    },
  ];
  const forgroundAssets = [
    {
      width: 135,
      right: '350px',
      top: '-20px',
      bottom: '',
      left: '',
      zindex: '',
      src: 'careers/hero/fg-dot-pill.svg',
    },
    {
      width: 20,
      right: '520px',
      top: '475px',
      src: 'careers/hero/fg-dot.svg',
    },
    {
      width: 78,
      right: '465px',
      top: '600px',
      src: 'careers/hero/fg-tag-hat.svg',
    },
    {
      width: 69,
      left: '350px',
      top: '265px',
      src: 'careers/hero/fg-wave-tag.svg',
    },
    {
      width: 102,
      left: '535px',
      top: '110px',
      src: 'careers/hero/fg-cursor2.svg',
    },
  ];
  const { containerRef, assetsRef } = useHeroSectionController();
  return (
    <WrapperBox ref={containerRef} paddingTop={15} paddingBottom={'19rem'}>
      <AssetsWrapperBox>
        <AssetsBox>
          {assets.map((asset, index) => (
            <ForgroundCloudImage
              key={index}
              src={asset.src}
              width={asset.width}
              right={asset.right}
              top={asset.top}
              circle={asset?.circle?.toString()}
              left={asset.left}
              bottom={asset.bottom}
              zindex={asset.zindex}
              isEagerLoading={true}
              optimization="aggressive"
            />
          ))}
        </AssetsBox>
        <ForgroundAssetsBox ref={assetsRef}>
          {forgroundAssets.map((forgroundAsset, index) => (
            <ForgroundCloudImage
              key={index}
              src={forgroundAsset.src}
              width={forgroundAsset.width}
              right={forgroundAsset.right}
              top={forgroundAsset.top}
              left={forgroundAsset.left}
              bottom={forgroundAsset.bottom}
              zindex={forgroundAsset.zindex}
              isEagerLoading={true}
              optimization="aggressive"
            />
          ))}
        </ForgroundAssetsBox>
      </AssetsWrapperBox>
      <HeroSectionContent id="careersDesktop" />
    </WrapperBox>
  );
};
